import type { ReactNode } from 'react';

export const symbol_price_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m558-206 219-219q9-9 21-9t21 9q9 9 9 21t-9 21L579-143q-9 9-21 9t-21-9L409-271q-9-9-9-21t9-21q9-9 21-9t21 9l107 107ZM270-392v-15h-80q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h190v-105H191q-13.18 0-22.09-8.91Q160-589.83 160-603v-164q0-12.75 8.63-21.38Q177.25-797 190-797h80v-15q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v15h80q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220v105h189q13.17 0 22.09 8.91Q440-614.17 440-601v164q0 12.75-8.62 21.37Q422.75-407 410-407h-80v15q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
